import type { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";
import type { CountryValue } from "./countries";
export type { CountryValue } from "./countries";

export const countryStates = ["US", "CA", "GB", "MX"] as const;

export const STATE_NAME_MESSAGES = {
	CA: {
		AB: msg({ message: "Alberta" }),
		BC: msg({ message: "British Columbia" }),
		MB: msg({ message: "Manitoba" }),
		NB: msg({ message: "New Brunswick" }),
		NL: msg({ message: "Newfoundland and Labrador" }),
		NS: msg({ message: "Nova Scotia" }),
		NT: msg({ message: "Northwest Territories" }),
		NU: msg({ message: "Nunavut" }),
		ON: msg({ message: "Ontario" }),
		PE: msg({ message: "Prince Edward Island" }),
		QC: msg({ message: "Quebec" }),
		SK: msg({ message: "Saskatchewan" }),
		YT: msg({ message: "Yukon" }),
	},
	US: {
		AL: msg({ message: "Alabama" }),
		AK: msg({ message: "Alaska" }),
		AZ: msg({ message: "Arizona" }),
		AR: msg({ message: "Arkansas" }),
		CA: msg({ message: "California" }),
		CO: msg({ message: "Colorado" }),
		CT: msg({ message: "Connecticut" }),
		DC: msg({ message: "District Of Columbia" }),
		DE: msg({ message: "Delaware" }),
		FL: msg({ message: "Florida" }),
		GA: msg({ message: "Georgia" }),
		HI: msg({ message: "Hawaii" }),
		ID: msg({ message: "Idaho" }),
		IL: msg({ message: "Illinois" }),
		IN: msg({ message: "Indiana" }),
		IA: msg({ message: "Iowa" }),
		KS: msg({ message: "Kansas" }),
		KY: msg({ message: "Kentucky" }),
		LA: msg({ message: "Louisiana" }),
		ME: msg({ message: "Maine" }),
		MD: msg({ message: "Maryland" }),
		MA: msg({ message: "Massachusetts" }),
		MI: msg({ message: "Michigan" }),
		MN: msg({ message: "Minnesota" }),
		MS: msg({ message: "Mississippi" }),
		MO: msg({ message: "Missouri" }),
		MT: msg({ message: "Montana" }),
		NE: msg({ message: "Nebraska" }),
		NV: msg({ message: "Nevada" }),
		NH: msg({ message: "New Hampshire" }),
		NJ: msg({ message: "New Jersey" }),
		NM: msg({ message: "New Mexico" }),
		NY: msg({ message: "New York" }),
		NC: msg({ message: "North Carolina" }),
		ND: msg({ message: "North Dakota" }),
		OH: msg({ message: "Ohio" }),
		OK: msg({ message: "Oklahoma" }),
		OR: msg({ message: "Oregon" }),
		PA: msg({ message: "Pennsylvania" }),
		RI: msg({ message: "Rhode Island" }),
		SC: msg({ message: "South Carolina" }),
		SD: msg({ message: "South Dakota" }),
		TN: msg({ message: "Tennessee" }),
		TX: msg({ message: "Texas" }),
		UT: msg({ message: "Utah" }),
		VT: msg({ message: "Vermont" }),
		VA: msg({ message: "Virginia" }),
		WA: msg({ message: "Washington" }),
		WV: msg({ message: "West Virginia" }),
		WI: msg({ message: "Wisconsin" }),
		WY: msg({ message: "Wyoming" }),
		AS: msg({ message: "American Samoa" }),
		GU: msg({ message: "Guam" }),
		MP: msg({ message: "Northern Mariana Islands" }),
		PR: msg({ message: "Puerto Rico" }),
		UM: msg({ message: "United States Minor Outlying Islands" }),
		VI: msg({ message: "Virgin Islands" }),
	},
	MX: {
		MX: msg({ message: "Mexico" }),
	},
	GB: {
		GB: msg({ message: "United Kingdom" }),
	},
} as const satisfies Record<string, Record<string, MessageDescriptor>>;

export const longToShortStates = {
	US: {
		Alabama: "AL",
		Alaska: "AK",
		Arizona: "AZ",
		Arkansas: "AR",
		California: "CA",
		Colorado: "CO",
		Connecticut: "CT",
		"District Of Columbia": "DC",
		Delaware: "DE",
		Florida: "FL",
		Georgia: "GA",
		Hawaii: "HI",
		Idaho: "ID",
		Illinois: "IL",
		Indiana: "IN",
		Iowa: "IA",
		Kansas: "KS",
		Kentucky: "KY",
		Louisiana: "LA",
		Maine: "ME",
		Maryland: "MD",
		Massachusetts: "MA",
		Michigan: "MI",
		Minnesota: "MN",
		Mississippi: "MS",
		Missouri: "MO",
		Montana: "MT",
		Nebraska: "NE",
		Nevada: "NV",
		"New Hampshire": "NH",
		"New Jersey": "NJ",
		"New Mexico": "NM",
		"New York": "NY",
		"North Carolina": "NC",
		"North Dakota": "ND",
		Ohio: "OH",
		Oklahoma: "OK",
		Oregon: "OR",
		Pennsylvania: "PA",
		"Rhode Island": "RI",
		"South Carolina": "SC",
		"South Dakota": "SD",
		Tennessee: "TN",
		Texas: "TX",
		Utah: "UT",
		Vermont: "VT",
		Virginia: "VA",
		Washington: "WA",
		"West Virginia": "WV",
		Wisconsin: "WI",
		Wyoming: "WY",
		"American Samoa": "AS",
		Guam: "GU",
		"Northern Mariana Islands": "MP",
		"Puerto Rico": "PR",
		"United States Minor Outlying Islands": "UM",
		"Virgin Islands": "VI",
	},
	CA: {
		Alberta: "AB",
		"British Columbia": "BC",
		Manitoba: "MB",
		"New Brunswick": "NB",
		"Newfoundland and Labrador": "NL",
		"Nova Scotia": "NS",
		Nunavut: "NU",
		"Northwest Territories": "NT",
		Ontario: "ON",
		"Prince Edward Island": "PE",
		Quebec: "QC",
		Saskatchewan: "SK",
		Yukon: "YT",
	},
	MX: {
		Mexico: "MX",
	},
	GB: {
		"United Kingdom": "GB",
	},
} as Record<string, Record<string, string>>;

export const shortToLongStates = {
	US: {
		AL: "Alabama",
		AK: "Alaska",
		AZ: "Arizona",
		AR: "Arkansas",
		CA: "California",
		CO: "Colorado",
		CT: "Connecticut",
		DC: "District Of Columbia",
		DE: "Delaware",
		FL: "Florida",
		GA: "Georgia",
		HI: "Hawaii",
		ID: "Idaho",
		IL: "Illinois",
		IN: "Indiana",
		IA: "Iowa",
		KS: "Kansas",
		KY: "Kentucky",
		LA: "Louisiana",
		ME: "Maine",
		MD: "Maryland",
		MA: "Massachusetts",
		MI: "Michigan",
		MN: "Minnesota",
		MS: "Mississippi",
		MO: "Missouri",
		MT: "Montana",
		NE: "Nebraska",
		NV: "Nevada",
		NH: "New Hampshire",
		NJ: "New Jersey",
		NM: "New Mexico",
		NY: "New York",
		NC: "North Carolina",
		ND: "North Dakota",
		OH: "Ohio",
		OK: "Oklahoma",
		OR: "Oregon",
		PA: "Pennsylvania",
		RI: "Rhode Island",
		SC: "South Carolina",
		SD: "South Dakota",
		TN: "Tennessee",
		TX: "Texas",
		UT: "Utah",
		VT: "Vermont",
		VA: "Virginia",
		WA: "Washington",
		WV: "West Virginia",
		WI: "Wisconsin",
		WY: "Wyoming",
		AS: "American Samoa",
		GU: "Guam",
		MP: "Northern Mariana Islands",
		PR: "Puerto Rico",
		UM: "United States Minor Outlying Islands",
		VI: "Virgin Islands",
	},
	CA: {
		AB: "Alberta",
		BC: "British Columbia",
		MB: "Manitoba",
		NB: "New Brunswick",
		NL: "Newfoundland and Labrador",
		NS: "Nova Scotia",
		NU: "Nunavut",
		NT: "Northwest Territories",
		ON: "Ontario",
		PE: "Prince Edward Island",
		QC: "Quebec",
		SK: "Saskatchewan",
		YT: "Yukon",
	},
	MX: {
		MX: "Mexico",
	},
	GB: {
		GB: "United Kingdom",
	},
} as Record<string, Record<string, string>>;

export function toShortState(
	country: (typeof countryStates)[number] | string | undefined,
	longState: string,
): string | undefined {
	if (!country) {
		return undefined;
	}

	return longToShortStates[country]?.[longState] ? longToShortStates[country]?.[longState] : longState;
}

export function toLongState(
	country: (typeof countryStates)[number] | string | undefined,
	shortState: keyof (typeof shortToLongStates)[(typeof countryStates)[number]] | string | undefined,
): string | undefined {
	if (!country) {
		return undefined;
	}

	return shortToLongStates[country]?.[shortState as keyof (typeof shortToLongStates)[(typeof countryStates)[number]]]
		? shortToLongStates[country]?.[shortState as keyof (typeof shortToLongStates)[(typeof countryStates)[number]]]
		: shortState;
}

export type LongStateNames =
	| keyof (typeof longToShortStates)["US"]
	| keyof (typeof longToShortStates)["CA"]
	| keyof (typeof longToShortStates)["MX"]
	| keyof (typeof longToShortStates)["GB"];
export type ShortStateCodes =
	| (typeof longToShortStates)["US"][LongStateNames]
	| (typeof longToShortStates)["CA"][LongStateNames]
	| (typeof longToShortStates)["MX"][LongStateNames]
	| (typeof longToShortStates)["GB"][LongStateNames];

export function getShortStatesMap(): Record<LongStateNames, ShortStateCodes> {
	return Object.values(longToShortStates).reduce(
		(acc, states) => {
			for (const [longName, shortCode] of Object.entries(states)) {
				acc[longName] = shortCode;
			}
			return acc;
		},
		{} as Record<LongStateNames, ShortStateCodes>,
	);
}

export function toShortStateWithoutCountry(longState: string) {
	const states = getShortStatesMap();
	const shortState = states[longState as LongStateNames];
	return shortState ?? longState;
}

export function getStateShortCodes(country: (typeof countryStates)[number]) {
	const states = shortToLongStates[country];

	return states ? Object.keys(states) : [];
}

export function getStateLongNames(country: (typeof countryStates)[number]) {
	const states = longToShortStates[country];

	return states ? Object.keys(states) : [];
}

export const countryValueToCountryCode = (country: CountryValue) => {
	const countryCodes = {
		"United States of America": "US",
		Canada: "CA",
		"United Kingdom": "GB",
		Mexico: "MX",
	};

	return countryCodes[country];
};

export const getStateNameDescriptor = (country: string, state: string): MessageDescriptor | undefined =>
	(STATE_NAME_MESSAGES as Record<string, Record<string, MessageDescriptor>>)[country]?.[state];
